/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
/*!*********************************************************!*\
  !*** ./resources/scripts/sections/recipe-cards/main.js ***!
  \*********************************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "recipeCards": () => (/* binding */ recipeCards)
/* harmony export */ });
var recipeCards = function recipeCards() {
  var $cards = document.querySelectorAll(".recipe-card");
  if ($cards) {
    $cards.forEach(function (card) {
      var $trigger = card.querySelector(".recipe-card__trigger");
      var $content = card.querySelector(".recipe-card__info");
      var $cardContent = card.querySelector(".recipe-card__content");
      if ($trigger) {
        var $icon = $trigger.querySelector(".recipe-card__trigger-icon");
        $trigger.addEventListener("click", function () {
          $cards.forEach(function (currentCard) {
            var $currentIcon = currentCard.querySelector(".recipe-card__trigger-icon");
            var $currentContent = currentCard.querySelector(".recipe-card__info");
            var $currentCardContent = currentCard.querySelector(".recipe-card__content");
            $currentContent.classList.add("translate-y-full");
            $currentIcon.classList.add("rotate-45");
            $currentCardContent.classList.remove("z-20");
            $currentCardContent.classList.add("pointer-events-none");
            $currentCardContent.classList.remove("pointer-events-auto");
          });
          $content.classList.remove("translate-y-full");
          $icon.classList.remove("rotate-45");
          $cardContent.classList.add("z-20");
          $cardContent.classList.remove("pointer-events-none");
          $cardContent.classList.add("pointer-events-auto");
        });
      }
    });
  }
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (recipeCards);
document.addEventListener("DOMContentLoaded", recipeCards);
/******/ })()
;